var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "assets-select" }, [
    _c(
      "div",
      { staticClass: "md-layout" },
      [
        _vm.pairs.length
          ? [
              _c("select-field", {
                staticClass: "md-layout-item assets-select__select",
                attrs: { label: _vm.i18n.chart_assets(), values: _vm.pairs },
                model: {
                  value: _vm.currentAsset,
                  callback: function($$v) {
                    _vm.currentAsset = $$v
                  },
                  expression: "currentAsset"
                }
              })
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ce92c0d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ce92c0d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/trade/index/components/chart/ChartWidget.AssetsSelect.vue
// module id = OQIT
// module chunks = 1